module.exports = __webpack_public_path__ + "img/bmi-graph.d9d24ecb.jpg";